<template>
  <div>
    <!--<h1>January 2020</h1>-->
    <div
      v-for="question in translatedQuestionnaire.fields"
      :key="question.id">
      <questionnaire-question
        :current-question="question"
        :title="question.title"
        :subtitle="question.properties.description"/>
      <component
        :is="getComponent(question.type)"
        :question="question"
        :answer="translatedAnswers[question.id]"/>
    </div>
  </div>
</template>

<script>
import QuestionnaireQuestion from '@/components/questionnaire/QuestionnaireQuestion'
import QuestionnaireNumber from '@/components/questionnaire/QuestionnaireNumber'
import QuestionnaireOpinionScale from '@/components/questionnaire/QuestionnaireOpinionScale'
import QuestionnaireMultipleChoice from '@/components/questionnaire/QuestionnaireMultipleChoice'
export default {
  name: 'QuestionnaireDisplay',
  components: {
    QuestionnaireQuestion,
    QuestionnaireNumber,
    QuestionnaireOpinionScale,
    QuestionnaireMultipleChoice
  },
  mixins: [],
  props: {
    questionnaire: {
      type: Object,
      required: true
    },
    answers: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    translatedAnswers: function () {
      let obj = JSON.parse(JSON.stringify(this.answers))
      let locale = this.questionnaire.id !== 'FifnQ8' ? this.$i18n.messages['en'] : this.$i18n.messages['de']
      let questionnaireId = this.questionnaire.id
      let answers = this.answers

      for (let questionId in answers) {
        let answerClone = JSON.parse(JSON.stringify(answers[questionId]))
        let translatedQn = locale.questionnaire[questionnaireId][questionId]

        // Quetion type `multiple_choice` that accepts only ONE choice
        if (answerClone.type === 'choice') {
          // Iterate through choices in locale file
          for (let choiceId in translatedQn.choices) {
            // Check if current choice is the same as answer
            if (translatedQn.choices[choiceId] === answerClone.choice.label) {
              // Replace answer label with translated choice
              answerClone.choice.label = this.$t(`questionnaire.${questionnaireId}.${questionId}.choices.${choiceId}`)
              break
            }
          }
        // Quetion type `multiple_choice` that accepts MULTIPLE choices
        } else if (answerClone.type === 'choices') {
          // Iterate through choices in answer array
          for (let index in answerClone.choices.labels) {
            // Iterate through choices in locale fale
            for (let choiceId in translatedQn.choices) {
              // Check if current choice is the same as answer
              if (translatedQn.choices[choiceId] === answerClone.choices.labels[index]) {
                // Replace current label with translated choice
                answerClone.choices.labels[index] = this.$t(`questionnaire.${questionnaireId}.${questionId}.choices.${choiceId}`)
                break
              }
            }
          }
        }

        // Add translated answer to object to be returned
        obj[questionId] = answerClone
      }

      return obj
    },

    translatedQuestionnaire: function () {
      let obj = JSON.parse(JSON.stringify(this.questionnaire))

      obj.fields.forEach(question => {
        // Translate title
        question.title = this.$t(`questionnaire.${obj.id}.${question.id}.title`)

        // Translate properties
        if (question.hasOwnProperty('properties')) {
          if (question.properties.hasOwnProperty('units')) question.properties.units = this.$t(`questionnaire.${obj.id}.${question.id}.properties.units`)
          if (question.properties.hasOwnProperty('labels')) question.properties.labels = this.$t(`questionnaire.${obj.id}.${question.id}.properties.labels`)
          if (question.properties.hasOwnProperty('description')) {
            question.properties.description = this.$t(`questionnaire.${this.questionnaire.id}.${question.id}.properties.description`)
          } else {
            question.properties.description = null
          }
        } else {
          question.properties = {}
          question.properties.description = null
        }

        // Translate choices
        if (question.type === 'multiple_choice') {
          for (let index in question.properties.choices) {
            let choice = question.properties.choices[index]
            choice.label = this.$t(`questionnaire.${obj.id}.${question.id}.choices.${choice.id}`)
          }
        }
      })

      return obj
    }
  },
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    getComponent (type) {
      switch (type) {
        case 'number':
          return 'QuestionnaireNumber'
        case 'opinion_scale':
          return 'QuestionnaireOpinionScale'
        case 'multiple_choice':
          return 'QuestionnaireMultipleChoice'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
